import SeoLanding from "../components/SeoLanding";

export default function CollegeIdCard() {
    return (
        <SeoLanding
            slug="college"
            keyword="college id card maker"
            audience="colleges"
            seoTitle="College ID Card Maker — Student & Faculty ID Cards | IDCardGen"
            seoDescription="Design and bulk-print college student / faculty ID cards online. Department-wise templates, QR check-in, Excel import and print-ready PDF export. Free trial."
            h1="A serious |college ID card maker| — for thousands of students."
            intro="From first-year admission rush to faculty re-issue, IDCardGen handles batch sizes that would crash a Word template. Department logos, semester colours, library QR — all in one editor."
            features={[
                {
                    title: "Department-wise batches",
                    body: "Filter Excel rows by department or year and export each batch with the matching template & lanyard colour.",
                },
                {
                    title: "Library / hostel QR",
                    body: "Generate QR codes per student that link to library check-out, hostel attendance or your own admin URL.",
                },
                {
                    title: "Front + back templates",
                    body: "Two-sided cards with rules, blood group, emergency contact, and college address on the back.",
                },
                {
                    title: "1000+ card exports",
                    body: "Memory-safe bulk pipeline rasterises one card at a time so even 5000-row exports stay stable.",
                },
                {
                    title: "Faculty / non-teaching",
                    body: "Separate templates for teaching, non-teaching and visiting faculty — managed under one account.",
                },
                {
                    title: "Reprint individual cards",
                    body: "Regenerate single cards for replacements without re-running the whole batch.",
                },
            ]}
            faqs={[
                {
                    q: "Can colleges have multiple admins?",
                    a: "Yes. Create separate accounts for each department head; the super-admin can adjust credits and view all generated batches.",
                },
                {
                    q: "What size should the photo be?",
                    a: "A passport-style 200 × 250 px JPG works best. Larger images are auto-resized; portrait orientation gives the cleanest result.",
                },
                {
                    q: "Can I add my college affiliation / university logo?",
                    a: "Yes — upload as a PNG with transparent background and place anywhere on the template. Same for ISO / NAAC accreditation badges.",
                },
                {
                    q: "Is the data stored securely?",
                    a: "Excel data is parsed in your browser. Generated cards are stored against your account; you can delete a template (and all its data) at any time from the dashboard.",
                },
                {
                    q: "Do you offer bulk pricing for universities?",
                    a: "Yes. Use the Request Demo button or email contact@idcardgen.com — we'll set up a custom credit pack and onboarding for your institution.",
                },
            ]}
        />
    );
}
